import React from "react";
import { styled } from '@mui/material/styles';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { connect } from "react-redux";
import {
  setFilteredResults,
  resetFilteredResults,
  setRenderedResults,
} from "../../actions/results";
import { incrementResults } from "../../constants";

const PREFIX = 'Sort';

const classes = {
  root: `${PREFIX}-root`,
  formControl: `${PREFIX}-formControl`,
  selectEmpty: `${PREFIX}-selectEmpty`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
	[`& .${classes.formControl}`]: {
	    background: "#fff",
	    margin: theme.spacing(1),
	    minWidth: 300,
	    [theme.breakpoints.down("sm")]: {
	    	margin: "1em 0",
	    },
		"& .MuiFormLabel-root": {
			color: "rgba(0,0,0,0.54)",
		},
	  },
	
	[`& .${classes.selectEmpty}`]: {
	    marginTop: theme.spacing(2),
	    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
	    	background: "#fff",
	    	padding: "0 0.7em",
	    },
	  },
}));
	
const StyledMenuItem = styled(MenuItem)((
  {
    theme
  }
) => ({
  [`& .${classes.formControl}`]: {
    background: "#fff",
    margin: theme.spacing(1),
    minWidth: 300,
    [theme.breakpoints.down("sm")]: {
      margin: "1em 0",
    },
		"& .MuiFormLabel-root": {
			color: "rgba(0,0,0,0.54)",
		},
  },

  [`& .${classes.selectEmpty}`]: {
    marginTop: theme.spacing(2),
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      background: "#fff",
      padding: "0 0.7em",
    },
  }
}));

const Sort = ({
  filteredResults,
  setFilteredResults,
  setRenderedResults,
  resetFilteredResults,
}) => {

  const [filter, setFilter] = React.useState("");

  const handleChange = (event) => {
    try {
      setFilter(event.target.value);
      let sorted;
      switch (event.target.value) {
        case "a-z":
          sorted = filteredResults.sort((a, b) => (a.name > b.name ? 1 : -1));
          setFilteredResults(sorted);
          setRenderedResults(sorted.slice(0, incrementResults));
          break;
        case "z-a":
          sorted = filteredResults.sort((a, b) => (a.name < b.name ? 1 : -1));
          setFilteredResults(sorted);
          setRenderedResults(sorted.slice(0, incrementResults));
          break;
        default:
          resetFilteredResults();
          console.info("no sort applied");
      }
    } catch (error) {
      console.error("Unable to apply sort");
    }
  };

  return (
	<Root className={classes.root}>
	    <div>
	      <FormControl variant="outlined" className={classes.formControl}>
	        <InputLabel id="demo-simple-select-outlined-label">Sort by</InputLabel>
	        <Select
	          labelId="demo-simple-select-outlined-label"
	          id="demo-simple-select-outlined"
	          value={filter}
	          onChange={handleChange}
	          label="Sort by"
	          className={classes.select}
	        >
	          <StyledMenuItem value="">
	            <em>None</em>
	          </StyledMenuItem>
	          <MenuItem value={"a-z"}>Name: A to Z</MenuItem>
	          <MenuItem value={"z-a"}>Name: Z to A</MenuItem>
	        </Select>
	      </FormControl>
	    </div>
	</Root>
  );
};
// TODO add event date sort
// <MenuItem value={"n-o"}>Event Date: Newest to Oldest</MenuItem>
// <MenuItem value={"o-n"}>Event Date: Oldest to Newest</MenuItem>

Sort.propTypes = {};

const mapStateToProps = (state) => ({
  filteredResults: state.results.filtered,
});

export default connect(mapStateToProps, {
  setFilteredResults,
  setRenderedResults,
  resetFilteredResults,
})(Sort);
